import React from 'react';
import ExternalRedirect from './ExternalRedirect';

const App = () => {
  return (
    <div>
      <ExternalRedirect to="https://linktr.ee/portocripto" />
    </div>
  );
};

export default App;
